module.exports = __webpack_public_path__ + "static/media/nightDemon.5e79fb21.png";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/nightDemon.png
// module id = 128
// module chunks = 0